import { addCustomEventListener } from '@Engage.Core';
class HtmlService {
    _isIterable(object) {
        if (!object) {
            return false;
        }
        if (this.isNode(object) || this.isElement(object) || object === window) {
            return false;
        }
        let r = this._isLiteralObject(object) || Array.isArray(object) || (typeof object === 'object' && object !== null && object['length'] !== undefined && object['length']);
        return r;
    }
    isNode(node) {
        if (typeof Node === 'object') {
            return node instanceof Node;
        }
        return node && typeof node === 'object' && typeof node.nodeType === 'number' && typeof node.nodeName === 'string';
    }
    ;
    isElement(element) {
        if (typeof HTMLElement === 'object') {
            return element instanceof HTMLElement;
        }
        return element && typeof element === 'object' && element.nodeType === 1 && typeof element.nodeName === 'string';
    }
    ;
    _getComputedStyle(element, prop) {
        let computedStyle;
        if (typeof window.getComputedStyle === 'function') { // normal browsers
            computedStyle = window.getComputedStyle(element);
        }
        else if (typeof document['currentStyle'] !== undefined) { // shitty browsers
            computedStyle = element.currentStyle;
        }
        else {
            computedStyle = element.style;
        }
        if (prop) {
            return computedStyle[prop];
        }
        else {
            return computedStyle;
        }
    }
    nodeListToArray(nodeList) {
        return Array.from(nodeList);
    }
    _isLiteralObject(object) {
        return object && typeof object === "object" && Object.getPrototypeOf(object) === Object.getPrototypeOf({});
    }
    _indexOf(array, obj) {
        if (Array.prototype.indexOf) {
            return Array.prototype.indexOf.call(array, obj);
        }
        for (let i = 0, j = array.length; i < j; i++) {
            if (array[i] === obj) {
                return i;
            }
        }
        return -1;
    }
    _getHandlerindex(element, event, handler) {
        const byHandler = element === document.body || element === window; // else by signature
        return byHandler ? this._indexOf(element._event[event].handlers, handler) : this._indexOf(element._event[event].signatures, String(handler));
    }
    addEventListener(element, event, handler) {
        if (!this.isNode(element) && element !== window) {
            throw new Error(element + " is not a DOMNode object");
        }
        element._event = element._event || {};
        element._event[event] = element._event[event] || { handlers: [], signatures: [] };
        // checks if listener doesn't exist
        if (this._getHandlerindex(element, event, handler) == -1) {
            const listener = addCustomEventListener(element, event, handler, false);
            element._event[event].handlers.push(listener);
            element._event[event].signatures.push(handler.toString());
        }
    }
    removeEventListener(element, event, handler) {
        if (!this.isNode(element) && element !== window) {
            throw new Error(element + " is not a DOMNode object");
        }
        if (element._event && element._event[event]) {
            const handlers = handler ? [handler] : [...element._event[event].handlers].reverse();
            handlers.forEach((currentHandler) => {
                const handlerindex = this._getHandlerindex(element, event, currentHandler);
                if (handlerindex !== -1) {
                    element._event[event].handlers.splice(handlerindex, 1);
                    element._event[event].signatures.splice(handlerindex, 1);
                }
                element.removeEventListener(event, currentHandler, false);
            });
        }
    }
}
export const htmlService = new HtmlService();
